module.exports = __webpack_public_path__ + "public/img/no-img.17ad971b.jpg";